import i18next from 'i18next';
import moment from 'moment';
import * as xlsx from 'xlsx';
declare var persianDate: (any) => void;
declare var persianDate: (any) => void;


export function DateToString(d: moment.Moment, lang: string, format: string, local: boolean) {
    if (d == null) return '';
    if (d instanceof String || typeof d == 'string') d = moment(d);
    let result = ''
    if (local) {
        d = d.clone().local();
    }
    if (lang == 'fa') {
        let date = new persianDate(d.toDate());
        result = date.format(format)
    } else {
        result = d.format(format);
    }
    return result;
}
export function isEmailValid(email) {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
}

export function translate(key: string, parameters: any): string {
    try {
        return i18next.t(key, parameters).toString();
    }
    catch (ex) {
        alert(key + "\n" + ex);
        return "";
    }
}

export function enterFullScreen() {
    let elem = <any>document.documentElement;
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}
export function IsPasswordStrong(password: string) {
    let score = 1;
    if (password == null)
        return false;
    if (password.length < 4)
        return false;
    if (password.length >= 8)
        score++;
    if (password.length >= 12)
        score++;
    if (/[0-9]+(\.[0-9][0-9]?)?/.test(password))
        score++;
    if (/^(?=.*[a-z])(?=.*[A-Z]).+$/.test(password))
        score++;
    if (/[!,@,#,$,%,^,&,*,?,_,~,-,£,(,)]/.test(password))
        score++;
    if (score < 3)
        return false;
    else
        return true;
}
export function balanceString(s: string): string {
    if (stringIsNullOrEmpty(s)) {
        return s;
    }
    else {
        let result = s;
        const regexYeh = /ۍ|ي|ى|ێ|ې|ۑ/g;
        const regexKeh = /ك|ڪ|ګ|ڬ|ڭ|ڮ/g;
        const regexCheh = /ڇ/g;
        result = result.replace(regexYeh, "ی");
        result = result.replace(regexKeh, "ک");
        result = result.replace(regexCheh, "چ");
        return result;

    }
}
export function distinct<T>(items: T[]): T[] {
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    var unique = items.filter(onlyUnique);
    return unique;

}
export function SearchRecursive<T>(items: T[], childFinder: (element: T) => T[], condition: (element: T) => boolean): T {
    let q = [];
    q.push(...items);
    while (q.length > 0) {
        let element = q.shift();
        if (condition(element)) {
            return element;
        }
        q.push(...childFinder(element));
    }
    return null;
}
export function SelectRecursive<T, TU>(parent: any, items: T[], sourceChildFinder: (element: T) => T[], mapper: (element: T, parent: any) => TU, destinationChildUpdater: (element: TU, children: TU[]) => void): TU[] {
    let result = items.map(x => {
        let r = mapper(x, parent);
        let children = SelectRecursive(r, sourceChildFinder(x), sourceChildFinder, mapper, destinationChildUpdater)
        destinationChildUpdater(r, children);
        return r;
    });
    return result;

}
export function stringIsNullOrEmpty(s: string): boolean {
    if (s == null)
        return true;
    else if (s.trim() == '')
        return true;
    else
        return false;
}

export function isUrlValid(url: string): boolean {
    try {
        new URL(url);
        return true
    } catch (err) {
        console.log(err);
        return false;
    }
}

export class UuidConverter {
    convertToBase8(uuid: string) {
        let uuidWithoutDash = (uuid + '0').replace(/-/g, "");
        let parts = uuidWithoutDash.match(/.{1,3}/g);
        let b8 = (parts.map(x => ('0000' + parseInt(x, 16).toString(8)).substr(-4))).join('');
        return b8;
    }
    ConvertFromBase8ToUUid(b8: string) {
        let parts = b8.match(/.{1,4}/g);
        let uuidWithoutDash = parts.map(x => ('000' + parseInt(x, 8).toString(16)).substr(-3)).join('').slice(0, -1);
        let uuid = uuidWithoutDash.slice(0, 8) + "-" + uuidWithoutDash.slice(8, 12) + "-" + uuidWithoutDash.slice(12, 16) + "-" + uuidWithoutDash.slice(16, 20) + "-" + uuidWithoutDash.slice(20);
        return uuid.toUpperCase();
    }
}
export class ExcelExporter {
    public export(name: string, data) {
        let workbook = xlsx.utils.book_new();
        let worksheet = xlsx.utils.json_to_sheet(data);
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        xlsx.writeFile(workbook, name, {
        });

    }
}

export class FileChooser {
    public maxsize: number;

    public async chooseFile(): Promise<{
        filename: string,
        fileContent: string,
        isChoosed: boolean
    }> {
        return new Promise((resolve, reject) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.style.display = 'none'; // Hide from user
            document.body.appendChild(input);

            input.onchange = (e: Event) => {
                const file = (e.target as HTMLInputElement).files?.[0];
                if (!file) {
                    cleanup();
                    resolve({ isChoosed: false, fileContent: null, filename: '' });
                    return;
                }

                if (this.maxsize && file.size > this.maxsize * 1024) {
                    alert("لطفا حجم فایل انتخابی کمتر از " + this.maxsize + " کیلو بایت باشد.");
                    cleanup();
                    resolve({ isChoosed: false, fileContent: null, filename: '' });
                    return;
                }

                const reader = new FileReader();
                reader.onload = () => {
                    const content = (reader.result as string).split(',')[1];
                    cleanup();
                    resolve({ isChoosed: true, fileContent: content, filename: file.name });
                };
                reader.onerror = reader.onerror = () => {
                    cleanup();
                    resolve({ isChoosed: false, fileContent: null, filename: '' });
                };
                reader.onabort = reader.onabort = () => {
                    cleanup();
                    resolve({ isChoosed: false, fileContent: null, filename: '' });
                };
                reader.readAsDataURL(file);
            };

            const cleanup = () => {
                document.body.removeChild(input);
            };

            // Ensure iOS sees this as immediate user interaction
            setTimeout(() => input.click(), 0);
        });
    }
}

export function isValidIranianNationalId(val: string): boolean {
    if (!/^[0-9]{10}$/.test(val)) {
        return false;
    }

    if (/^(\d)\1{9}$/.test(val)) {
        return false;
    }

    const digits = Array.from(val, Number);
    const sum = digits.slice(0, 9).reduce((total, digit, index) => total + digit * (10 - index), 0);
    const remainder = sum % 11;
    const checkDigit = digits[9];

    return remainder < 2 ? checkDigit === remainder : checkDigit === 11 - remainder;
}

export function isValidIranianPhoneNumber(val: string, internal = true, international = false): boolean {
    if(internal){
        return /^09\d{9}$/.test(val);
    }

    if(international){
        return /^\+989\d{9}$/.test(val);
    }

    if(internal && international){
        return /^(\+98|0)?9\d{9}$/.test(val);
    }

    return null;
}